import React, {useEffect} from 'react';
import { Alert, Box, Button, Divider, Stack, TextField, Typography } from '@mui/material';

interface AddTrustedDeviceStepProps {
    addTrustedDevice: CallableFunction,
    continueWithoutAddingTrustedDevice: CallableFunction,
    deviceName: string,
    setDeviceName: CallableFunction,
}

function detectDeviceName(): string {
    const ua = navigator.userAgent;

    let browser = 'Przeglądarka';
    if ((navigator as any).userAgentData?.brands?.length) {
        const dominated = ['Chromium', 'Not', 'Google Chrome'];
        const brand = (navigator as any).userAgentData.brands.find(
            (b: any) => !dominated.some(d => b.brand.startsWith(d))
        );
        if (brand) browser = brand.brand;
        else if (ua.includes('Chrome')) browser = 'Chrome';
    } else if (ua.includes('Firefox/')) browser = 'Firefox';
    else if (ua.includes('Edg/')) browser = 'Edge';
    else if (ua.includes('Safari/') && !ua.includes('Chrome')) browser = 'Safari';
    else if (ua.includes('Chrome/')) browser = 'Chrome';

    let os = '';
    if ((navigator as any).userAgentData?.platform) {
        os = (navigator as any).userAgentData.platform;
    } else if (ua.includes('Windows')) os = 'Windows';
    else if (ua.includes('Mac OS')) os = 'macOS';
    else if (ua.includes('Android')) os = 'Android';
    else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
    else if (ua.includes('Linux')) os = 'Linux';

    return [browser, os].filter(Boolean).join(', ');
}

export default function AddTrustedDeviceStep({addTrustedDevice, continueWithoutAddingTrustedDevice, deviceName, setDeviceName}: AddTrustedDeviceStepProps) {
    useEffect(() => {
        if (!deviceName) {
            setDeviceName(detectDeviceName());
        }
    }, []);
    const __ = (window as any).__ ? (window as any).__ as (text: string) => string : (text: string) => text;

    return <Box>
        <Typography sx={{ mb: 4 }} variant="body2" color="text.secondary" gutterBottom align="center">
            {__('Jeśli to Twoje osobiste urządzenie, możemy je zapamiętać. Dzięki temu przy kolejnym logowaniu nie będziemy Cię prosić o kod weryfikacyjny. Swoimi zaufanymi urządzeniami możesz zarządzać w dowolnym momencie w sekcji "Ustawienia użytkownika".')}
        </Typography>
        <Stack sx={{ mb: 4 }} spacing={4} direction="column">
            <TextField
                id="outlined-basic"
                label={__('Nazwa urządzenia')}
                helperText={__('Nadaj nazwę temu urządzeniu, np. Laptop domowy.')}
                value={deviceName}
                onChange={(e) => setDeviceName(e.target.value)}
                fullWidth
            />
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack spacing={2} direction="row" justifyContent="center">
            <Button onClick={() => {addTrustedDevice()}} variant="contained">
                {__('Zapamiętaj to urządzenie')}
            </Button>
            <Button onClick={() => {continueWithoutAddingTrustedDevice()}} variant="outlined">
                {__('Nie zapamiętuj')}
            </Button>
        </Stack>
        <Alert severity="info" sx={{ mt: 2 }}>
            <Stack spacing={1.5}>
                <Box>
                    <Typography variant="subtitle2" component="div" sx={{ fontWeight: 700 }}>
                        {__('Zapamiętaj to urządzenie')}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 400 }}>
                        {__('Wybierz na prywatnym sprzęcie. Nie będziemy pytać o kod 2FA przy kolejnych logowaniach z tego urządzenia.')}
                    </Typography>
                </Box>
                <Box>
                    <Typography variant="subtitle2" component="div" sx={{ fontWeight: 700 }}>
                        {__('Nie zapamiętuj')}
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 400 }}>
                        {__('Wybierz na urządzeniu publicznym lub współdzielonym. Kod 2FA będzie wymagany przy każdym logowaniu.')}
                    </Typography>
                </Box>
            </Stack>
        </Alert>
    </Box>;
}
